/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HealthControllerCheckQueryResponse } from "../../models/healthController/HealthControllerCheck";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { healthControllerCheck } from "../../clients/healthService/healthControllerCheck";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const healthControllerCheckQueryKey = () => [{
  url: '/health'
}] as const;
export type HealthControllerCheckQueryKey = ReturnType<typeof healthControllerCheckQueryKey>;
export function healthControllerCheckQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = healthControllerCheckQueryKey();
  return queryOptions<HealthControllerCheckQueryResponse, ResponseErrorConfig<Error>, HealthControllerCheckQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return healthControllerCheck(config);
    }
  });
}

/**
 * @summary Basic health check
 * {@link /health}
 */
export function useHealthControllerCheck<TData = HealthControllerCheckQueryResponse, TQueryData = HealthControllerCheckQueryResponse, TQueryKey extends QueryKey = HealthControllerCheckQueryKey>(options: {
  query?: Partial<QueryObserverOptions<HealthControllerCheckQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? healthControllerCheckQueryKey();
  const query = useQuery({
    ...healthControllerCheckQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}